import { render, staticRenderFns } from "./StudentDetailCard.vue?vue&type=template&id=57cc5a66&scoped=true&"
import script from "./StudentDetailCard.vue?vue&type=script&lang=js&"
export * from "./StudentDetailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cc5a66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
